import PatientActivityTable from './PatientActivityTable';

interface PatientActivityProps {
  patientId: string;
}
const PatientActivity = ({ patientId }: PatientActivityProps) => (
  <PatientActivityTable patientId={patientId} />
);

export default PatientActivity;
